import type { PaginatedRequestParams, PaginatedResponse } from '@/types/api';
import type { LaunchedSurvey } from '@/types/cycle-evaluation/LaunchedSurvey';

import { api } from '@/api/api';

export default {
    async getSurveys({
        pageNumber,
        pageSize,
        meta,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<
        PaginatedResponse<LaunchedSurvey>
    > {
        const sentCycleId = meta?.sentCycleId;

        if (!sentCycleId) {
            throw new Error('sentCycleId is required to fetch surveys');
        }

        const response = await api.get<PaginatedResponse<LaunchedSurvey>>(
            `/cycleevaluation/${sentCycleId}/surveys`,
            {
                params: { pageNumber, pageSize },
                signal,
            },
        );

        return response.data;
    },

    async exportSurveys(sentCycleId: string): Promise<Blob> {
        if (!sentCycleId) {
            throw new Error('sentCycleId is required to export surveys');
        }

        const response = await api.get<Blob>(`/cycleevaluation/${sentCycleId}/surveys/export`, {
            responseType: 'blob',
        });

        return response.data;
    },
};
